import { Link } from 'react-router-dom';

export default function SeoContentSection() {
  return (
    <section
      className="border-t border-slate-200/80 bg-white py-16 sm:py-20"
      aria-labelledby="seo-content-heading"
    >
      <article className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8">
        <h2 id="seo-content-heading" className="sr-only">
          Learn about QR codes
        </h2>

        <h3 className="text-2xl font-bold text-slate-900">What is a QR code?</h3>
        <p className="mt-4 leading-relaxed text-slate-600">
          A QR code (Quick Response code) is a two-dimensional barcode that stores
          information such as a website URL, plain text, contact details, or WiFi
          credentials. When scanned with a smartphone camera or QR reader app, the
          encoded data is decoded instantly — making it one of the fastest ways to
          bridge physical and digital experiences.
        </p>

        <h3 className="mt-10 text-2xl font-bold text-slate-900">Why use QR codes?</h3>
        <p className="mt-4 leading-relaxed text-slate-600">
          QR codes are used on product packaging, restaurant menus, event tickets,
          business cards, and marketing materials because they remove typing friction.
          A single scan can open a landing page, connect to WiFi, start an email, or
          display instructions. For businesses, they improve conversion on print
          campaigns and make offline touchpoints measurable when paired with your own
          analytics on the destination page.
        </p>

        <h3 className="mt-10 text-2xl font-bold text-slate-900">
          How to generate QR codes online
        </h3>
        <p className="mt-4 leading-relaxed text-slate-600">
          Using our{' '}
          <a href="#generator" className="font-medium text-indigo-600 hover:text-indigo-700">
            free QR code generator
          </a>{' '}
          is straightforward: choose your content type — URL, plain text, email, phone
          call, SMS, vCard contact card, or WiFi network — enter your data, customize
          dot style, colors, optional frame, and logo, then download a PNG or SVG file.
          The preview updates in real time as you type. For best scan reliability, use
          strong contrast between foreground and background, avoid extremely small print
          sizes, and test the code on multiple devices before mass printing.
        </p>

        <h3 className="mt-10 text-2xl font-bold text-slate-900">
          WiFi, vCard, SMS, and call QR codes
        </h3>
        <p className="mt-4 leading-relaxed text-slate-600">
          Beyond simple link QR codes, PixelUtility supports practical everyday formats.
          A <strong>WiFi QR code</strong> lets guests join your network without typing a
          password. A <strong>vCard QR code</strong> shares contact details for business
          cards. <strong>SMS</strong> and <strong>call</strong> codes pre-fill a message
          or dial a number — useful for customer support, bookings, and marketing campaigns.
        </p>

        <h3 className="mt-10 text-2xl font-bold text-slate-900">
          Are PixelUtility QR codes permanent?
        </h3>
        <p className="mt-4 leading-relaxed text-slate-600">
          Static QR codes created here encode your content directly into the image.
          They do not expire because of our service — there is no redirect layer or
          account tied to the file you download. If you encode a URL, the code remains
          valid as long as that URL works. If you change your destination later, you
          will need to generate and distribute a new code (unless you use a dynamic QR
          solution on your own infrastructure).
        </p>

        <h3 className="mt-10 text-2xl font-bold text-slate-900">
          Can I use QR codes commercially?
        </h3>
        <p className="mt-4 leading-relaxed text-slate-600">
          Yes. QR codes you generate and download from PixelUtility may be used in
          commercial projects including advertisements, packaging, signage, and client
          deliverables. You are responsible for the accuracy of the encoded content and
          compliance with applicable laws (for example, privacy rules when linking to
          data collection pages). We recommend keeping a master SVG export for brand
          consistency across materials. Questions? See our{' '}
          <a href="/#faq" className="font-medium text-indigo-600 hover:text-indigo-700">
            FAQ
          </a>{' '}
          or read the{' '}
          <Link to="/privacy" className="font-medium text-indigo-600 hover:text-indigo-700">
            privacy policy
          </Link>
          .
        </p>
      </article>
    </section>
  );
}
